import './LineItemResultGroup.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import ExpandToggle from '../../../components/ExpandToggle/ExpandToggle';
import useExpandCollapse from '../../../hooks/useExpandCollapse';
import type { TagSheetSaveAdItem } from '../../../types';
import { mapAdItemToAdRowDisplay, mapCreativeItemToCreativeRowDisplay } from '../../mapResultRowDisplay';
import type { LineItemHeaderDisplay } from '../../types';
import AdResultRow from '../AdResultRow/AdResultRow';
import CreativeResultRow from '../CreativeResultRow/CreativeResultRow';

const [block, element] = bem('line-item-result-group');

export type LineItemResultGroupProps = {
  groupId: string;
  headerDisplay: LineItemHeaderDisplay;
  ads: TagSheetSaveAdItem[];
};

const LineItemResultGroup = ({ groupId, headerDisplay, ads }: LineItemResultGroupProps): React.JSX.Element => {
  const { isExpanded, toggleExpand } = useExpandCollapse();

  return (
    <div className={block()}>
      <div className={element('header')}>
        <ExpandToggle isExpanded={isExpanded(groupId)} onToggle={(): void => toggleExpand(groupId)} />
        <div className={element('header-content')}>
          <div>
            <b>Line Item ID:</b> {headerDisplay.lineItemId}
          </div>
          <div>
            <b>Line Item Name:</b> {headerDisplay.lineItemName || '-'}
          </div>
          <div>
            <b>Ad Product:</b> {headerDisplay.adProductDisplayName || '-'}
          </div>
        </div>
      </div>
      {isExpanded(groupId) &&
        ads.map((adItem, adIndex) => {
          const adId = `${groupId}-ad-${adIndex}`;
          const adDisplay = mapAdItemToAdRowDisplay(adItem);

          return (
            <React.Fragment key={adId}>
              <AdResultRow
                adId={adId}
                adResult={adDisplay}
                hasCreative={true}
                isExpanded={isExpanded(adId)}
                onToggleExpand={(): void => toggleExpand(adId)}
              />
              {isExpanded(adId) && (
                <CreativeResultRow creativeResult={mapCreativeItemToCreativeRowDisplay(adItem.creativeEntity)} />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default LineItemResultGroup;
